module.exports = __webpack_public_path__ + "08606f68dbde3c47bb6573845d3ebead.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/select-shapes/images/Triangle@2x.png
// module id = 330
// module chunks = 0